import { render, staticRenderFns } from "./QuestionTemplateUsageDialog.vue?vue&type=template&id=ed362ca6&scoped=true"
import script from "./QuestionTemplateUsageDialog.vue?vue&type=script&lang=js"
export * from "./QuestionTemplateUsageDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionTemplateUsageDialog.vue?vue&type=style&index=0&id=ed362ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed362ca6",
  null
  
)

export default component.exports